import { Controller } from "@hotwired/stimulus"

// Switches between object-cover and object-contain based on how well the image's
// natural aspect ratio matches its container. If the mismatch is too extreme
// (e.g. a wide banner in a square box), cropping looks bad — contain it instead.
const MISMATCH_THRESHOLD = 2.5

export default class extends Controller {
  connect() {
    const img = this.element
    if (img.complete && img.naturalWidth > 0) {
      this.#assess()
    } else {
      img.addEventListener("load", () => this.#assess(), { once: true })
    }
  }

  #assess() {
    const img = this.element
    const naturalRatio = img.naturalWidth / img.naturalHeight
    const container = img.parentElement
    const containerRatio = container.offsetWidth / container.offsetHeight

    const mismatch = Math.max(naturalRatio / containerRatio, containerRatio / naturalRatio)

    if (mismatch > MISMATCH_THRESHOLD) {
      img.classList.replace("object-cover", "object-contain")
      container.style.backgroundColor = "var(--reader-surface)"
    }
  }
}
